export default {
  STORE: {
    ANDROID: 'ANDROID',
    IOS: 'IOS',
  },
  STATUS: {
    CONSTRUCTION: 'CONSTRUCTION',
    PUBLICATION_IN_PROGRESS: 'PUBLICATION_IN_PROGRESS',
    PUBLICATION_ONLINE: 'PUBLICATION_ONLINE',
    PACKAGING_IN_PROGRESS: 'PACKAGING_IN_PROGRESS',
    PACKAGING_DONE: 'PACKAGING_DONE',
    ARCHIVED: 'ARCHIVED',
  },
  STORE_STATUS: {
    NOT_PUBLISH: 'NOT_PUBLISH',
    PUBLISHING: 'PUBLISHING',
    FAILED: 'FAILED',
    PUBLISHED: 'PUBLISHED',
  },
  STYLES: {
    SPLASHSCREEN: 'PICTURE_SCREEN_SPLASHSCREEN',
    CATEGORIES: {
      PALETTE: 'PALETTE',
      COLORS: 'APPLICATION_COLOR',
    },
    ELEMENTS: {
      COLOR_ID_1: 'COLOR_ID_1',
      COLOR_ID_2: 'COLOR_ID_2',
      COLOR_ID_3: 'COLOR_ID_3',
      COLOR_USER_COLOR_1: 'COLOR_USER_COLOR_1',
      COLOR_USER_COLOR_2: 'COLOR_USER_COLOR_2',
      COLOR_USER_COLOR_3: 'COLOR_USER_COLOR_3',
    },
  },
  CONTENTS: {
    SECTIONS: ['entries', 'userEntries', 'page'],
    DEFAULT: 'TEXT',
    TYPE: ['IMAGE', 'VIDEO', 'HTML', 'URL', 'PDF', 'ACTION'],
  },
  DESIGN: {
    APPLICATION_DESIGN: 'APPLICATION_DESIGN',
  },
  CONFIGURATION: {
    APPLICATION_TYPE_MENU: 'APPLICATION_TYPE_MENU',
    AUTHS: ['GAMO', 'Facebook', 'Twitter', 'AZURE_AD', 'WS', 'LDAP'],
    PROFILE_INFO: [ 'firstname', 'lastname', 'email',
      'phone', 'mobilePhone', 'company', 'function',
      'login', 'age',
      'addrLine1', 'addrLine2', 'zipCode', 'city', 'country'],
  },
  NAVIGATION: {
    TYPE: ['SIDE_MENU', 'SIDE_MENU_ICON', 'SHAPE_ICON_MENU', 'TWO_COLS_TILES_SIDE_MENU', 'TAB_BAR_NAVIGATION'],
  },
  BUTTON_POSITION: [
    'FLOATING',
    'FIXED',
  ],
  BUTTON_STYLE: [
    'TEXT',
    'ICON',
    'TEXT_ICON',
  ],
  BACK_BUTTON_TYPE: [
    'CHEVRON',
    'SQUARED_CHEVRON',
  ],
  SHAPE_ICON: [
    'close',
    'CIRCLE',
    'HEXA',
    'HEXA_VERTICAL',
    'RECT',
    'DIAMOND',
    'HEART',
    'OCTO',
    'PENTAGONE',
    'STAR',
    'LONG_BUTTON',
  ],
  PADDING: ['NONE', 'LIGHT', 'BIG'],
  SECTIONS: {
    DASHBOARD: ['HEADER_SLIDESHOW_TILES', 'HEADER_SLIDESHOW', 'SLIDE_SHOW_FULLSCREEN', 'HONEYCOMB', 'TAB_CONTAINER',
      'FLOW', 'SWAY'],
    LIST: ['GENERIC_LIST', 'LIVE_2', 'CARDS', 'MATERIAL_CARDS', 'LEFT_RIGHT_CARDS', 'PEOPLE', 'ACTION_LIST'],
    PLANNERS: ['TIMELINE', 'AGENDA'],
    RSS: ['RSS_CLASSIC', 'RSS_CARDS'],
  },
  DASHBOARD: [
    'SLATE',
    'TILES',
    'HEADER_TILES',
    'HEADER_SLIDESHOW_TILES',
    'HEADER_IMAGES_GALLERY',
    'GALLERY',
    'HEADER_GALLERY_BACKGROUND',
    'GALLERY_BACKGROUND',
    'HEADER_SLIDESHOW',
    'SLIDE_SHOW_FULLSCREEN',
  ],
  ACTION: {
    TYPE: ['SECTION', 'SUBSECTION', 'POPUP', 'PLAN', 'URL', 'SYNC', 'LOGIN', 'CREATE_ACCOUNT', 'RESET_PWD',
      'CHANGE_PWD', 'LOGOUT', 'SUBSCRIPTION'],
    SYNC_TYPE: ['SECTION', 'SUBSECTION', 'TOKEN', 'CLEAN_CACHE'],
  },
  BEACONS_ACTIONS: {
    DETECTION_TYPES: ['PROXIMITY', 'ENTER_ZONE', 'EXIT_ZONE'],
    FREQUENCY_TYPES: ['ONCE', 'EVERY_MIN', 'EVERY_15_MIN', 'EVERY_30_MIN', 'EVERY_HOUR', 'EVERY_6_HOURS', 'EVERY_DAY'],
  },
  MEDIA: {
    TYPE: ['IMAGE', 'PDF', 'VIDEO'],
  },
  AUDIO_SIGNAL: [
    {NAME: '00010', FILE: '00010.mp3'},
    {NAME: '00020', FILE: '00020.mp3'},
    {NAME: '00030', FILE: '00030.mp3'},
    {NAME: '00040', FILE: '00040.mp3'},
    {NAME: '00050', FILE: '00050.mp3'},
    {NAME: '00060', FILE: '00060.mp3'},
    {NAME: '00070', FILE: '00070.mp3'},
    {NAME: '00080', FILE: '00080.mp3'},
    {NAME: '00090', FILE: '00090.mp3'},
    {NAME: '000A0', FILE: '000A0.mp3'},
    {NAME: '000B0', FILE: '000B0.mp3'},
    {NAME: '000C0', FILE: '000C0.mp3'},
    {NAME: '000D0', FILE: '000D0.mp3'},
    {NAME: '000E0', FILE: '000E0.mp3'},
    {NAME: '000F0', FILE: '000F0.mp3'},

  ],

  USER_RIGHTS: {
    CONFIG: {
      DATA_POI: 'DATA_POI',
      DATA_LOCALISATION_BEACON: 'DATA_LOCALISATION_BEACON',
      DATA_LOCALISATION_STIMSHOP: 'DATA_LOCALISATION_STIMSHOP',
      DATA_KEY_VALUE: 'DATA_KEY_VALUE',
      DATA_FILE: 'DATA_FILE',
      DATA_MAPWIZE: 'DATA_MAPWIZE',
      DATA_PLANNING: 'DATA_PLANNING',
      DATA_CHECKIN: 'DATA_CHECKIN',
      DATA_CHAT: 'DATA_CHAT',
      DATA_RESOURCE_MANAGER: 'DATA_RESOURCE_MANAGER',
      DATA_FORM: 'DATA_FORM',
      DATA_DM: 'DATA_DM',
      DATA_GENERIC: 'DATA_GENERIC',
    },
    CONTENT: {
      PLUGIN: 'PLUGIN',
      PLANNER: 'PLANNER',
      CHAT: 'CHAT',
      MAPWIZE: 'MAPWIZE',
      STIMSHOP: 'STIMSHOP',
      FILE: 'FILE',
      KEY_VALUE: 'KEY_VALUE',
      RESOURCE_MANAGER: 'RESOURCE_MANAGER',
      FORM: 'FORM',
      DM: 'DM',
    },
  },
  SYNC_TYPES: {
    DATASOURCE_PLANNER: 'DATASOURCE_PLANNER',
    DATASOURCE_KEY_VALUE: 'DATASOURCE_KEY_VALUE',
  },
  POI: {
    GOOGLE_MAPS: 'GOOGLE_MAPS',
    MAPWIZE: 'MAPWIZE',
  },
  GROUP: {
    TYPES: ['SPACE', 'GROUP', 'AZURE_AD'],
  },
}
